import React from "react";

interface GroupIconProps {
  color?: string;
}

export default function GroupIcon({ color = "#fff" }: GroupIconProps) {
  return (
    <svg
      id="Combine"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_10334"
        data-name="Caminho 10334"
        d="M14.909,0A9.107,9.107,0,0,0,6.268,6.268,9.091,9.091,0,1,0,17.732,17.732,9.091,9.091,0,0,0,14.909,0ZM9.091,21.818A6.908,6.908,0,0,1,5.822,8.823c0,.089,0,.178,0,.267a9.1,9.1,0,0,0,9.091,9.091c.089,0,.179,0,.267,0A6.915,6.915,0,0,1,9.091,21.818Zm9.087-6.642c0-.089,0-.178,0-.267A9.1,9.1,0,0,0,9.091,5.818c-.089,0-.179,0-.267,0a6.908,6.908,0,1,1,9.354,9.354Z"
        fill={color}
      />
    </svg>
  );
}
